// extracted by mini-css-extract-plugin
export default {"card":"AlertServiceList_card__xgrpC","addBtn":"AlertServiceList_addBtn__+KkKn"};